import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type MaterialAssetsRenderingMaterialFragment = { __typename: 'Material', id: string, legacyId: number, name?: string | null, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number, graphNode: any } | null, organization?: { __typename: 'Organization', id: string, legacyId: number, materialAssetsTemplate?: { __typename: 'Template', legacyId: number, id: string } | null } | null };

export type MaterialAssetsRenderingMaterialQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type MaterialAssetsRenderingMaterialQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, legacyId: number, name?: string | null, latestCyclesRevision?: { __typename: 'MaterialRevision', id: string, legacyId: number, graphNode: any } | null, organization?: { __typename: 'Organization', id: string, legacyId: number, materialAssetsTemplate?: { __typename: 'Template', legacyId: number, id: string } | null } | null } };

export type MaterialAssetsRenderingCreateJobTaskMutationVariables = Types.Exact<{
  input: Types.MutationCreateJobInput;
}>;


export type MaterialAssetsRenderingCreateJobTaskMutation = { __typename: 'Mutation', createJob: { __typename: 'Job', id: string, legacyId: number } };

export type MaterialAssetsRenderingMaterialGraphQueryVariables = Types.Exact<{
  legacyId: Types.Scalars['Int']['input'];
}>;


export type MaterialAssetsRenderingMaterialGraphQuery = { __typename: 'Query', materialRevision: { __typename: 'MaterialRevision', graphNode: any } };

export type MaterialAssetsRenderingMaterialRangeFragment = { __typename: 'Tag', fullWidth?: number | null, repeatWidth?: number | null, repeatHeight?: number | null, railroaded: boolean, overviewTemplateType?: Types.FabricOverviewGenerateTemplateType | null };

export type MaterialAssetsRenderingMaterialRangeQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
}>;


export type MaterialAssetsRenderingMaterialRangeQuery = { __typename: 'Query', material: { __typename: 'Material', tagAssignments: Array<{ __typename: 'TagAssignment', tag: { __typename: 'Tag', fullWidth?: number | null, repeatWidth?: number | null, repeatHeight?: number | null, railroaded: boolean, overviewTemplateType?: Types.FabricOverviewGenerateTemplateType | null } }>, outputForType?: { __typename: 'MaterialOutput', result?: { __typename: 'DataObject', id: string, thumbnail?: { __typename: 'DataObject', id: string } | null } | null } | null } };

export const MaterialAssetsRenderingMaterialFragmentDoc = gql`
    fragment MaterialAssetsRenderingMaterial on Material {
  id
  legacyId
  name
  latestCyclesRevision {
    id
    legacyId
    graphNode
  }
  organization {
    id
    legacyId
    materialAssetsTemplate {
      legacyId
      id
    }
  }
}
    `;
export const MaterialAssetsRenderingMaterialRangeFragmentDoc = gql`
    fragment MaterialAssetsRenderingMaterialRange on Tag {
  fullWidth
  repeatWidth
  repeatHeight
  railroaded
  overviewTemplateType
}
    `;
export const MaterialAssetsRenderingMaterialDocument = gql`
    query materialAssetsRenderingMaterial($materialId: ID!) {
  material(id: $materialId) {
    ...MaterialAssetsRenderingMaterial
  }
}
    ${MaterialAssetsRenderingMaterialFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetsRenderingMaterialGQL extends Apollo.Query<MaterialAssetsRenderingMaterialQuery, MaterialAssetsRenderingMaterialQueryVariables> {
    override document = MaterialAssetsRenderingMaterialDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialAssetsRenderingCreateJobTaskDocument = gql`
    mutation materialAssetsRenderingCreateJobTask($input: MutationCreateJobInput!) {
  createJob(input: $input) {
    id
    legacyId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetsRenderingCreateJobTaskGQL extends Apollo.Mutation<MaterialAssetsRenderingCreateJobTaskMutation, MaterialAssetsRenderingCreateJobTaskMutationVariables> {
    override document = MaterialAssetsRenderingCreateJobTaskDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialAssetsRenderingMaterialGraphDocument = gql`
    query materialAssetsRenderingMaterialGraph($legacyId: Int!) {
  materialRevision(legacyId: $legacyId) {
    graphNode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetsRenderingMaterialGraphGQL extends Apollo.Query<MaterialAssetsRenderingMaterialGraphQuery, MaterialAssetsRenderingMaterialGraphQueryVariables> {
    override document = MaterialAssetsRenderingMaterialGraphDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MaterialAssetsRenderingMaterialRangeDocument = gql`
    query materialAssetsRenderingMaterialRange($materialId: ID!) {
  material(id: $materialId) {
    tagAssignments(tagTypes: [MaterialRange]) {
      tag {
        ...MaterialAssetsRenderingMaterialRange
      }
    }
    outputForType(type: TileableImage) {
      result {
        id
        thumbnail(fileType: tiff, resolution: High) {
          id
        }
      }
    }
  }
}
    ${MaterialAssetsRenderingMaterialRangeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialAssetsRenderingMaterialRangeGQL extends Apollo.Query<MaterialAssetsRenderingMaterialRangeQuery, MaterialAssetsRenderingMaterialRangeQueryVariables> {
    override document = MaterialAssetsRenderingMaterialRangeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }